export default __webpack_public_path__ + "static/media/caret-down.74c29b3c.svg";